import * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['math_map'] = function (block: Blockly.Block): [string, number] {
        const value = gen.valueToCode(block, 'VALUE', 0) || '0';
        const fromLow = gen.valueToCode(block, 'FROM_LOW', 0) || '0';
        const fromHigh = gen.valueToCode(block, 'FROM_HIGH', 0) || '1023';
        const toLow = gen.valueToCode(block, 'TO_LOW', 0) || '0';
        const toHigh = gen.valueToCode(block, 'TO_HIGH', 0) || '100';
        return expr(`map(${value}, ${fromLow}, ${fromHigh}, ${toLow}, ${toHigh})`);
    };
}
